import { Button } from "@/components/ui/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuShortcut,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import PlusLineIcon from "@/components/icons/plus-line"
import LinkCircleIcon from "@/components/icons/link-circle"
import ArrowDownIcon from "@/components/icons/arrow-down"
import { useNavigate } from "react-router-dom"
import { useUser } from "@/api/users"
import { WithdrawalModal } from "@/wallet/withdrawal.modal"
import { useState } from "react"
import { useHotkeys } from "react-hotkeys-hook"
import PaperFoldTextIcon from "@/components/icons/paper-fold-text"

export function ActionsMenu() {
  const navigate = useNavigate()
  const { user } = useUser()
  const [withdrawalOpen, setWithdrawalOpen] = useState(false)

  useHotkeys("shift+p", () => navigate("/payment-links/create"))
  useHotkeys("shift+i", () => navigate("/invoices/create"))
  useHotkeys("shift+w", () => setWithdrawalOpen(true))

  if (!user) return null

  return (
    <>
      <WithdrawalModal open={withdrawalOpen} onOpenChange={setWithdrawalOpen} />
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="circle" size="icon">
            <PlusLineIcon />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="w-56">
          <DropdownMenuLabel>Online payments</DropdownMenuLabel>
          <DropdownMenuGroup>
            <DropdownMenuItem onClick={() => navigate("/payment-links/create")}>
              <LinkCircleIcon />
              Payment Link
              <DropdownMenuShortcut>shift+P</DropdownMenuShortcut>
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => navigate("/invoices/create")}>
              <PaperFoldTextIcon />
              Invoice
              <DropdownMenuShortcut>shift+I</DropdownMenuShortcut>
            </DropdownMenuItem>
          </DropdownMenuGroup>
          <DropdownMenuLabel>Balance</DropdownMenuLabel>
          <DropdownMenuItem
            disabled={!user.hasWallet}
            onClick={() => setWithdrawalOpen(true)}
          >
            <ArrowDownIcon />
            Withdraw
            <DropdownMenuShortcut>shift+W</DropdownMenuShortcut>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  )
}
